import { type, Entity, validatedResource, association, resource, repository } from 'aurelia-orm';
import { AttachmentInfoRepository } from 'data/service/attachment-info-repository';
import { autoinject } from 'aurelia-framework';


@resource("AttachmentInfo")
@repository(AttachmentInfoRepository)
export class AttachmentInfo extends Entity {
    id: number;
    description: number;
    createdDate: Date;
    isActive: boolean;
    parentGuid: string;
    fileName: string;
    size: number;
    currentVersionId: number;
    fileExtension: string;
    entityStatusId: number;
}